import React, { useContext, useMemo } from "react";
import { useQuery } from "@apollo/client/react";
import { DataGrid } from "@mui/x-data-grid";
import moment from "moment";
import { Tooltip, Typography } from "@mui/material";
import { useTextDomainContext } from "@/app/providers";
import { GET_SCRAPPER_LOGS } from "@/hooks";

export const ScraperLog = () => {
  // const [scrapperData, setScrapperData] = useState([]);
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);

  const { data: scrapperDataList, loading } = useQuery<any>(GET_SCRAPPER_LOGS, {
    variables: {
      scrapperName: "",
      createdAt: "",
    },
  });

  interface ScrapperLogItem {
    scrapperName?: string;
    url?: string;
    status?: string;
    createdAt?: string;
    lastRun?: string;
    description?: string;
    updatedAt?: string;
  }

  interface ScraperRow {
    id: number;
    scrapper_name?: string;
    url?: string;
    status?: string;
    created_at?: string;
    lastRun?: string;
    description?: string;
    updatedAt?: string;
  }

  const scrapperData = useMemo<ScraperRow[]>(() => {
    let returnData: ScraperRow[] = [];
    if (!loading) {
      const { scrapperLogs } = scrapperDataList || {};
      const list: ScraperRow[] = [];
      (scrapperLogs || []).forEach((item: ScrapperLogItem, index: number) => {
        list.push({
          id: index + 1,
          scrapper_name: item.scrapperName,
          url: item.url,
          status: item.status,
          created_at: item.createdAt,
          lastRun: item.lastRun,
          description: item?.description,
          updatedAt: item?.updatedAt,
        });
      });
      returnData = list;
    }
    return returnData;
  }, [scrapperDataList, loading]);

  /**
   *
   * @param row
   */
  function columnFormater(row: ScraperRow) {
    return (
      <Tooltip title={row?.description} arrow>
        <Typography noWrap>{row?.description}</Typography>
      </Tooltip>
    );
  }

  const columns = [
    {
      field: "id",
      headerName: gettext("ID"),
      flex: 0.5,
      headerAlign: "left",
    },
    {
      field: "scrapper_name",
      headerName: gettext("Scraper Name"),
      flex: 2,
      headerAlign: "left",
    },
    {
      field: "url",
      headerName: gettext("URL"),
      flex: 3,
      headerAlign: "left",
    },
    {
      field: "description",
      headerName: gettext("Description"),
      flex: 3,
      headerAlign: "left",
      renderCell: (params: { row?: ScraperRow }) =>
        columnFormater(params?.row as ScraperRow),
    },
    {
      field: "status",
      headerName: gettext("Status"),
      flex: 1,
      headerAlign: "left",
    },
    {
      field: "updatedAt",
      headerName: gettext("Created At"),
      flex: 1,
      headerAlign: "left",
      valueFormatter: (params: { value?: any; row?: ScraperRow }) =>
        moment(params.row?.updatedAt || params.value).format(
          "DD/MM/YYYY HH:MM",
        ),
    },
  ];

  return (
    <>
      <div className="card card-custom gutter-b example example-compact">
        <div className="table-div m-0">
          <div className="table-title">
            <h3>{gettext("Scraper Log")}</h3>
          </div>
          <div className="card-body">
            <div
              style={{
                width: "100%",
              }}
            >
              <DataGrid
                rows={scrapperData}
                columns={columns as any}
                initialState={{
                  pagination: { paginationModel: { pageSize: 100 } },
                  sorting: {
                    sortModel: [
                      {
                        field: "created_at",
                        sort: "asc",
                      },
                    ],
                  },
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
